import {
    createUploadSessionByDriveId,
    createUploadSessionBySiteId,
    createUploadSessionByUserId,
    uploadFile
} from "../apis/msGraph";
import {
    teamsFileDataFromChannel,
    teamsFileDataFromChat
} from "./fetchFile";
import { getTeamsDataFromUrl } from "../utils/utils";
import { TEAMS_ENTRY_FROM } from "@/modules/queryData.types";

export async function uploadFileFromTeams(file: File) {
    const { entryFrom, driveId, fileId, chatUserId } = await getTeamsDataFromUrl();
    let data;
    switch (entryFrom) {
        case TEAMS_ENTRY_FROM.LEGACY:
            data = await createUploadSessionBySiteId(teamsFileDataFromChannel.siteId, teamsFileDataFromChannel.fileId);
            break;

        case TEAMS_ENTRY_FROM.CHANNEL_TAB:
        case TEAMS_ENTRY_FROM.TASK_MODULE_FROM_MESSAGE_EXTENSION_CARD:
            data = await createUploadSessionByDriveId(driveId, fileId);
            break;

        case TEAMS_ENTRY_FROM.TASK_MODULE_FROM_CHANNEL:
            data = await createUploadSessionBySiteId(teamsFileDataFromChannel.siteId, teamsFileDataFromChannel.fileId);
            break;

        case TEAMS_ENTRY_FROM.TASK_MODULE_FROM_CHAT:
            data = await createUploadSessionByUserId(chatUserId!, teamsFileDataFromChat.fileId);
            break;

        default:
            break;
    }
    const uploadUrl = data.uploadUrl;
    return uploadFile(uploadUrl, file);
}
